(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSelectedLabels(root) {
      root.querySelectorAll(
        '.variant-option--buttons:not(.variant-option--swatches) input[type="radio"]'
      ).forEach(function (input) {
        var label = input.closest('.variant-option__button-label');
        if (label) label.classList.toggle('is-selected', input.checked);
      });
    }

    function handleVariantClick(input) {
      var form = input.closest('form');
      if (!form) return;
      form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (sibling) {
        var label = sibling.closest('.variant-option__button-label');
        if (label) label.classList.toggle('is-selected', sibling === input);
      });
    }

    document.addEventListener('change', function (event) {
      if (
        event.target.type === 'radio' &&
        event.target.closest('.variant-option--buttons:not(.variant-option--swatches)')
      ) {
        handleVariantClick(event.target);
      }
    });

    document.addEventListener('click', function (event) {
      var label = event.target.closest(
        '.variant-option--buttons:not(.variant-option--swatches) .variant-option__button-label'
      );
      if (!label) return;
      var input = label.querySelector('input[type="radio"]');
      if (input) handleVariantClick(input);
    });

    document.addEventListener('DOMContentLoaded', function () {
      initSelectedLabels(document);
    });
    document.addEventListener('shopify:section:rendered', function (e) {
      initSelectedLabels(e.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
